import Spinner from './spinner'

export type { SpinnerProps } from './spinner'

export { Spinner }
